import { patchRequest } from '@/core';
import { preferredVendors } from '@/requests';

export default async function updatePreferredVendorRequest(id, patch) {
	let url = preferredVendors.getByIdPath(id);
	let response = await patchRequest(url, {}, patch);
	return response;
}